export default "__VITE_ASSET__NFo$IvhH__"